import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Trophy } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { RankBadge } from "@/components/landing/ClipVisuals";

export const RankShare = () => {
  const { t, lang } = useI18n();
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/stats/rank").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r) return null;
  const download = async (fmt) => {
    setBusy(fmt);
    try {
      const { data } = await api.get("/stats/badge.png", { params: { fmt, lang: lang === "fr" ? "fr" : "en" }, responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `clip-ex-${r.badge}-${fmt}.png`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };
  return (
    <div className="cx-card cx-brackets rounded-2xl p-6 mt-6 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="rank-share">
      <Trophy className="w-8 h-8 text-[#ffc94d] shrink-0" />
      <div className="flex-1 min-w-0">
        {r.rank ? (<>
          <div className="flex flex-wrap items-center gap-2"><span className="font-display text-xl text-white" data-testid="rank-share-rank">#{r.rank} {t("pf.this_month")}</span><RankBadge badge={r.badge} testid="rank-share-badge" /></div>
          <p className="text-sm text-slate-400 mt-1">{t("rk.ranked")}</p>
        </>) : <p className="text-sm text-slate-400" data-testid="rank-share-unranked">{t("rk.unranked")}</p>}
      </div>
      {r.rank && (
        <div className="flex gap-2">
          {[["square", t("rk.square")], ["story", t("rk.story")]].map(([fmt, label]) => (
            <button key={fmt} onClick={() => download(fmt)} disabled={!!busy} data-testid={`rank-download-${fmt}`}
              className="cx-ghost rounded-full px-4 py-2 text-xs text-white flex items-center gap-2"><Download className="w-3.5 h-3.5" />{busy === fmt ? "…" : label}</button>
          ))}
        </div>
      )}
    </div>
  );
};
